import React, { useState } from 'react';
import PublishStatusComponent from '../../components/PublishStatusComponent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Published } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Core/PathItems';
import { Result } from '@peercolab/engine/esm';



interface EditCourseCategoryProps {
  name: string;
  translationKey: string;
  status: Published;
  onBack: () => void;
  onSave: (name: string, translationKey: string) => void;
  onTransition: (action: string) => Promise<Result<any>>;
}



const EditCourseCategory: React.FC<EditCourseCategoryProps> = ({ status, onTransition, name: initialName, translationKey: initialTranslationKey, onBack, onSave }) => {
  const [name, setName] = useState(initialName);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={onBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>Edit Category</Typography>
        </Box>
        <PublishStatusComponent
          status={status}
          onTransition={onTransition}
        />
      </Box>
      <TextField
        label="Category Name"
        value={name}
        onChange={e => setName(e.target.value)}
        fullWidth
        sx={{ mb: 3 }}
      />
      <TextField
        label="Translation Key"
        value={initialTranslationKey}
        disabled
        fullWidth
        sx={{ mb: 3 }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={() => onSave(name, initialTranslationKey)}>Save</Button>
        <Button onClick={onBack}>Cancel</Button>
      </Box>
    </Box>
  );
};

export default EditCourseCategory;
